export function parsePageResponse(response) {

    let headers = [... Object.keys(response.headers)].filter(hdr => hdr.startsWith("x"))
        .reduce((previousValue, currentValue) => {
            previousValue[currentValue] = response.headers[currentValue];
            return previousValue;
        }, {});

    return Promise.resolve({
            meta: {
                count: +headers["x-count"],
                page: +headers["x-page"],
                pageCount: +headers["x-page-count"],
                pageSize: +headers["x-page-size"]
            },
            list: response.data
        })
}

function extractPageable(pagination) {
    if(typeof pagination != 'undefined' && typeof pagination.page != 'undefined') {
        return `?page=${pagination.page}&size=${pagination.pageSize}`;
    }
    return '?';
}

export default {
    parsePageResponse
}
